var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_c('input',{attrs:{"type":"submit","name":"submit","value":"Logout"}})])}
var staticRenderFns = []

export { render, staticRenderFns }